import React from 'react';

/**
 * Reusable Accordion component
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Accordion = _ref => {
  let {
    title,
    isOpen,
    onToggle,
    children
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: "property-group accordion-group",
    children: [/*#__PURE__*/_jsxs("div", {
      className: `accordion-header ${isOpen ? 'expanded' : ''}`,
      onClick: onToggle,
      children: [/*#__PURE__*/_jsx("label", {
        className: "section-label",
        children: title
      }), /*#__PURE__*/_jsx("span", {
        className: "accordion-icon",
        children: isOpen ? '−' : '+'
      })]
    }), isOpen && /*#__PURE__*/_jsx("div", {
      className: "accordion-content",
      children: children
    })]
  });
};